import Address from '@/models/Address';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class AddressComponent extends Vue {
    @Prop({ type: Object }) public address: Address;
}
